/**
 * Created by takeo on 2016/08/29.
 */
import '../admin-common-js';



// WEBPACK FOOTER //
// ./es6/admin-pages-js/default.page.js